import type { StylesConfig } from 'src/components/DropdownWrapper/DropdownWrapper';
import { dropdownWrapper } from 'src/assets/colors';

export const getCompetitionSelectStyles = <T, IsMulti extends boolean>(): StylesConfig<T, IsMulti> => ({
    control: (base) => ({
        ...base,
        minHeight: '40px',
        height: '40px',
    }),
    valueContainer: (base) => ({
        ...base,
        padding: '0 8px',
        height: '40px',
    }),
    input: (base) => ({
        ...base,
        fontSize: '14px',
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        left: '12px',
    }),
    placeholder: (base) => ({
        ...base,
        fontSize: '14px',
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        left: '12px',
    }),
    singleValue: (base) => ({
        ...base,
        fontSize: '14px',
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        left: '12px',
    }),
    clearIndicator: (base) => ({
        ...base,
        display: 'flex',
        padding: '4px',
        cursor: 'pointer',
        color: dropdownWrapper.noOptions.txtColor,
        '&:hover': {
            color: dropdownWrapper.control.txtColor,
        },
    }),
    dropdownIndicator: () => ({
        display: 'none',
    }),
    menu: (base) => ({
        ...base,
        zIndex: 1000,
    }),
    menuList: (base) => ({
        ...base,
        maxHeight: '180px',
        overflowY: 'auto',
    }),
    option: (base, state) => ({
        ...base,
        fontSize: '14px',
        backgroundColor: state.isSelected
            ? dropdownWrapper.option.bgColorSelected
            : state.isFocused
              ? dropdownWrapper.option.bgColorFocused
              : 'transparent',
        color: dropdownWrapper.control.txtColor,
        cursor: 'pointer',
        '&:active': {
            backgroundColor: dropdownWrapper.option.bgColorHover,
        },
    }),
});
